/**
 * KET Vocabulary - Other themes (simplified for this demo)
 * Includes: body_health, shopping, travel_transport, weather_environment, time_dates, work_jobs, clothes_accessories
 */
import { KETWord } from './index';

// Body and Health theme (100 words)
export const bodyHealthWords: KETWord[] = [
  { word: 'body', meaning: '身体', example: 'I exercise my body.' },
  { word: 'head', meaning: '头', example: 'I have a headache.' },
  { word: 'hair', meaning: '头发', example: 'I have black hair.' },
  { word: 'face', meaning: '脸', example: 'I wash my face.' },
  { word: 'eye', meaning: '眼睛', example: 'I have two eyes.' },
  { word: 'ear', meaning: '耳朵', example: 'I hear with my ears.' },
  { word: 'nose', meaning: '鼻子', example: 'My nose is small.' },
  { word: 'mouth', meaning: '嘴巴', example: 'Open your mouth.' },
  { word: 'tooth', meaning: '牙齿', example: 'I brush my teeth.' },
  { word: 'teeth', meaning: '牙齿（复数）', example: 'I clean my teeth.' },
  { word: 'arm', meaning: '手臂', example: 'I have two arms.' },
  { word: 'hand', meaning: '手', example: 'I write with my hand.' },
  { word: 'finger', meaning: '手指', example: 'I have ten fingers.' },
  { word: 'leg', meaning: '腿', example: 'I have two legs.' },
  { word: 'foot', meaning: '脚', example: 'My feet are tired.' },
  { word: 'feet', meaning: '脚（复数）', example: 'I wash my feet.' },
  { word: 'knee', meaning: '膝盖', example: 'I hurt my knee.' },
  { word: 'shoulder', meaning: '肩膀', example: 'My shoulder hurts.' },
  { word: 'back', meaning: '背', example: 'I have back pain.' },
  { word: 'stomach', meaning: '胃', example: 'I have a stomach ache.' },
  { word: 'health', meaning: '健康', example: 'Health is important.' },
  { word: 'healthy', meaning: '健康的', example: 'I am healthy.' },
  { word: 'ill', meaning: '生病的', example: 'I feel ill today.' },
  { word: 'sick', meaning: '病的', example: 'I am sick.' },
  { word: 'tired', meaning: '疲劳的', example: 'I am tired.' },
  { word: 'strong', meaning: '强壮的', example: 'I want to be strong.' },
  { word: 'weak', meaning: '虚弱的', example: 'I feel weak.' },
  { word: 'cold', meaning: '感冒', example: 'I have a cold.' },
  { word: 'flu', meaning: '流感', example: 'I have the flu.' },
  { word: 'fever', meaning: '发烧', example: 'I have a fever.' },
  { word: 'headache', meaning: '头痛', example: 'I have a headache.' },
  { word: 'cough', meaning: '咳嗽', example: 'I have a cough.' },
  { word: 'pain', meaning: '疼痛', example: 'I have pain in my leg.' },
  { word: 'hurt', meaning: '受伤', example: 'My arm hurts.' },
  { word: 'doctor', meaning: '医生', example: 'I went to see the doctor.' },
  { word: 'nurse', meaning: '护士', example: 'The nurse helped me.' },
  { word: 'hospital', meaning: '医院', example: 'I went to the hospital.' },
  { word: 'medicine', meaning: '药', example: 'I take medicine.' },
  { word: 'pill', meaning: '药片', example: 'I took a pill.' },
  { word: 'ambulance', meaning: '救护车', example: 'Call an ambulance!' },
  { word: 'happy', meaning: '快乐的', example: 'I am happy.' },
  { word: 'sad', meaning: '悲伤的', example: 'I feel sad.' },
  { word: 'angry', meaning: '生气的', example: 'I am angry.' },
  { word: 'worried', meaning: '担心的', example: 'I am worried about the test.' },
  { word: 'nervous', meaning: '紧张的', example: 'I am nervous.' },
  { word: 'scared', meaning: '害怕的', example: 'I am scared.' },
  { word: 'afraid', meaning: '害怕的', example: 'I am afraid of dogs.' },
  { word: 'surprised', meaning: '惊讶的', example: 'I was surprised.' },
  { word: 'excited', meaning: '兴奋的', example: 'I am excited about the trip.' },
  { word: 'bored', meaning: '无聊的', example: 'I feel bored.' },
  { word: 'shy', meaning: '害羞的', example: 'I am shy.' },
  { word: 'lonely', meaning: '孤独的', example: 'I feel lonely.' },
  { word: 'love', meaning: '爱', example: 'I love my family.' },
  { word: 'hate', meaning: '恨', example: 'I hate rainy days.' },
  { word: 'like', meaning: '喜欢', example: 'I like apples.' },
  { word: 'exercise', meaning: '锻炼', example: 'I exercise every day.' },
  { word: 'sport', meaning: '运动', example: 'I like sports.' },
  { word: 'run', meaning: '跑', example: 'I run every morning.' },
  { word: 'swim', meaning: '游泳', example: 'I can swim.' },
  { word: 'fit', meaning: '健康的', example: 'I am fit and strong.' },
  { word: 'weight', meaning: '体重', example: 'I want to lose weight.' },
  { word: 'diet', meaning: '饮食', example: 'A healthy diet is important.' },
  { word: 'allergy', meaning: '过敏', example: 'I have an allergy.' },
  { word: 'temperature', meaning: '体温', example: 'My temperature is high.' },
  { word: 'appointment', meaning: '预约', example: 'I have an appointment with the doctor.' },
  { word: 'hungry', meaning: '饿的', example: 'I am hungry.' },
  { word: 'thirsty', meaning: '渴的', example: 'I am thirsty.' },
  { word: 'sleep', meaning: '睡觉', example: 'I need to sleep.' },
  { word: 'rest', meaning: '休息', example: 'I need a rest.' },
  { word: 'blood', meaning: '血', example: 'There is blood on my finger.' },
  { word: 'bone', meaning: '骨头', example: 'I broke a bone.' },
  { word: 'muscle', meaning: '肌肉', example: 'I have strong muscles.' },
  { word: 'brain', meaning: '大脑', example: 'My brain works hard.' },
  { word: 'breathe', meaning: '呼吸', example: 'I breathe fresh air.' },
];

// Shopping theme (82 words)
export const shoppingWords: KETWord[] = [
  { word: 'shop', meaning: '商店', example: 'I go to the shop.' },
  { word: 'store', meaning: '商店', example: 'I went to the store.' },
  { word: 'market', meaning: '市场', example: 'We went to the market.' },
  { word: 'supermarket', meaning: '超市', example: 'I shop at the supermarket.' },
  { word: 'mall', meaning: '购物中心', example: 'We went to the mall.' },
  { word: 'shopping centre', meaning: '购物中心', example: 'I went to the shopping centre.' },
  { word: 'bookshop', meaning: '书店', example: 'I bought a book at the bookshop.' },
  { word: 'clothes shop', meaning: '服装店', example: 'I went to a clothes shop.' },
  { word: 'pharmacy', meaning: '药店', example: 'I went to the pharmacy.' },
  { word: 'bakery', meaning: '面包店', example: 'I bought bread at the bakery.' },
  { word: 'product', meaning: '产品', example: 'This product is good.' },
  { word: 'item', meaning: '物品', example: 'I bought three items.' },
  { word: 'goods', meaning: '商品', example: 'The goods are on sale.' },
  { word: 'brand', meaning: '品牌', example: 'I like this brand.' },
  { word: 'size', meaning: '尺寸', example: 'What size do you want?' },
  { word: 'colour', meaning: '颜色', example: 'What colour do you like?' },
  { word: 'price', meaning: '价格', example: 'The price is low.' },
  { word: 'cost', meaning: '成本', example: 'How much does it cost?' },
  { word: 'money', meaning: '钱', example: 'I have some money.' },
  { word: 'cash', meaning: '现金', example: 'I paid in cash.' },
  { word: 'credit card', meaning: '信用卡', example: 'I paid by credit card.' },
  { word: 'bill', meaning: '账单', example: 'Here is the bill.' },
  { word: 'receipt', meaning: '收据', example: 'Keep the receipt.' },
  { word: 'change', meaning: '零钱', example: 'Here is your change.' },
  { word: 'cheap', meaning: '便宜的', example: 'This is cheap.' },
  { word: 'expensive', meaning: '贵的', example: 'That is expensive.' },
  { word: 'sale', meaning: '促销', example: 'The sale starts today.' },
  { word: 'discount', meaning: '折扣', example: 'There is a discount.' },
  { word: 'buy', meaning: '买', example: 'I want to buy a book.' },
  { word: 'sell', meaning: '卖', example: 'They sell books here.' },
  { word: 'pay', meaning: '支付', example: 'I paid ten dollars.' },
  { word: 'spend', meaning: '花费', example: 'I spent five dollars.' },
  { word: 'save', meaning: '节省', example: 'I saved money.' },
  { word: 'choose', meaning: '选择', example: 'I chose a red one.' },
  { word: 'try on', meaning: '试穿', example: 'I want to try on these shoes.' },
  { word: 'look for', meaning: '寻找', example: 'I am looking for a book.' },
  { word: 'find', meaning: '找到', example: 'I found what I wanted.' },
  { word: 'customer', meaning: '顾客', example: 'The customer is waiting.' },
  { word: 'assistant', meaning: '店员', example: 'The assistant helped me.' },
  { word: 'cashier', meaning: '收银员', example: 'I paid the cashier.' },
  { word: 'bag', meaning: '袋子', example: 'Put it in a bag.' },
  { word: 'packet', meaning: '小包', example: 'I bought a packet of biscuits.' },
  { word: 'package', meaning: '包裹', example: 'I received a package.' },
  { word: 'box', meaning: '盒子', example: 'Put it in a box.' },
  { word: 'bottle', meaning: '瓶子', example: 'I bought a bottle of water.' },
  { word: 'can', meaning: '罐', example: 'I bought a can of soda.' },
  { word: 'open', meaning: '开门', example: 'The shop is open.' },
  { word: 'closed', meaning: '关门', example: 'The shop is closed.' },
];

// Travel and Transport theme (106 words)
export const travelTransportWords: KETWord[] = [
  { word: 'transport', meaning: '交通', example: 'Public transport is good.' },
  { word: 'car', meaning: '汽车', example: 'My dad drives a car.' },
  { word: 'bus', meaning: '公交车', example: 'I take the bus to school.' },
  { word: 'train', meaning: '火车', example: 'The train is fast.' },
  { word: 'plane', meaning: '飞机', example: 'We travel by plane.' },
  { word: 'airplane', meaning: '飞机', example: 'The airplane is big.' },
  { word: 'bike', meaning: '自行车', example: 'I ride my bike to school.' },
  { word: 'bicycle', meaning: '自行车', example: 'I have a new bicycle.' },
  { word: 'taxi', meaning: '出租车', example: 'I took a taxi.' },
  { word: 'boat', meaning: '船', example: 'We went on a boat.' },
  { word: 'ship', meaning: '大船', example: 'The ship was huge.' },
  { word: 'ferry', meaning: '渡船', example: 'We took a ferry.' },
  { word: 'underground', meaning: '地铁', example: 'I take the underground.' },
  { word: 'subway', meaning: '地铁', example: 'The subway is crowded.' },
  { word: 'metro', meaning: '地铁', example: 'I use the metro.' },
  { word: 'station', meaning: '车站', example: 'Meet me at the station.' },
  { word: 'bus station', meaning: '公交车站', example: 'The bus station is near here.' },
  { word: 'train station', meaning: '火车站', example: 'We went to the train station.' },
  { word: 'airport', meaning: '机场', example: 'We went to the airport.' },
  { word: 'port', meaning: '港口', example: 'The ship arrived at the port.' },
  { word: 'car park', meaning: '停车场', example: 'I parked in the car park.' },
  { word: 'parking lot', meaning: '停车场', example: 'The parking lot is full.' },
  { word: 'ticket', meaning: '票', example: 'I need a ticket.' },
  { word: 'passport', meaning: '护照', example: 'I have a passport.' },
  { word: 'visa', meaning: '签证', example: 'I need a visa.' },
  { word: 'luggage', meaning: '行李', example: 'My luggage is heavy.' },
  { word: 'suitcase', meaning: '手提箱', example: 'I packed my suitcase.' },
  { word: 'bag', meaning: '包', example: 'I have a travel bag.' },
  { word: 'backpack', meaning: '背包', example: 'I travel with a backpack.' },
  { word: 'map', meaning: '地图', example: 'Look at the map.' },
  { word: 'travel', meaning: '旅行', example: 'I like to travel.' },
  { word: 'go', meaning: '去', example: 'I go to school by bus.' },
  { word: 'come', meaning: '来', example: 'I come home by car.' },
  { word: 'arrive', meaning: '到达', example: 'I arrive at 5pm.' },
  { word: 'depart', meaning: '出发', example: 'The train departs at 9am.' },
  { word: 'leave', meaning: '离开', example: 'We leave at 8am.' },
  { word: 'return', meaning: '返回', example: 'I will return tomorrow.' },
  { word: 'journey', meaning: '旅程', example: 'The journey was long.' },
  { word: 'trip', meaning: '旅行', example: 'We went on a trip.' },
  { word: 'flight', meaning: '航班', example: 'The flight was long.' },
  { word: 'drive', meaning: '开车', example: 'I drive to work.' },
  { word: 'ride', meaning: '骑车', example: 'I ride my bike.' },
  { word: 'fly', meaning: '飞行', example: 'I fly to London tomorrow.' },
  { word: 'walk', meaning: '走路', example: 'I walk to school.' },
  { word: 'direction', meaning: '方向', example: 'Which direction is the station?' },
  { word: 'left', meaning: '左边', example: 'Turn left.' },
  { word: 'right', meaning: '右边', example: 'Turn right.' },
  { word: 'straight', meaning: '直的', example: 'Go straight.' },
  { word: 'north', meaning: '北', example: 'The station is north of here.' },
  { word: 'south', meaning: '南', example: 'Go south.' },
  { word: 'east', meaning: '东', example: 'The sun rises in the east.' },
  { word: 'west', meaning: '西', example: 'The sun sets in the west.' },
  { word: 'opposite', meaning: '对面', example: 'The shop is opposite the school.' },
  { word: 'next to', meaning: '旁边', example: 'The bank is next to the shop.' },
  { word: 'near', meaning: '近', example: 'My house is near the school.' },
  { word: 'far', meaning: '远', example: 'The airport is far from here.' },
  { word: 'cross', meaning: '穿过', example: 'Cross the street.' },
  { word: 'crossing', meaning: '人行横道', example: 'Use the crossing.' },
  { word: 'traffic lights', meaning: '红绿灯', example: 'Stop at the traffic lights.' },
  { word: 'corner', meaning: '角落', example: 'The shop is on the corner.' },
  { word: 'city', meaning: '城市', example: 'I live in a big city.' },
  { word: 'town', meaning: '城镇', example: 'My town is small.' },
  { word: 'village', meaning: '村庄', example: 'My grandparents live in a village.' },
  { word: 'country', meaning: '国家', example: 'I love my country.' },
  { word: 'abroad', meaning: '国外', example: 'I want to go abroad.' },
  { word: 'hotel', meaning: '酒店', example: 'We stayed in a hotel.' },
  { word: 'campsite', meaning: '露营地', example: 'We stayed at a campsite.' },
  { word: 'tent', meaning: '帐篷', example: 'We slept in a tent.' },
  { word: 'beach', meaning: '海滩', example: 'We went to the beach.' },
  { word: 'mountain', meaning: '山', example: 'We climbed the mountain.' },
  { word: 'river', meaning: '河', example: 'The river is long.' },
  { word: 'lake', meaning: '湖', example: 'We swam in the lake.' },
  { word: 'island', meaning: '岛', example: 'We visited an island.' },
  { word: 'sightseeing', meaning: '观光', example: 'We went sightseeing.' },
  { word: 'tourist', meaning: '游客', example: 'There are many tourists.' },
  { word: 'road', meaning: '路', example: 'The road is busy.' },
  { word: 'street', meaning: '街道', example: 'I live on this street.' },
  { word: 'way', meaning: '路', example: 'Which way is the station?' },
  { word: 'bridge', meaning: '桥', example: 'We crossed the bridge.' },
  { word: 'traffic', meaning: '交通', example: 'There is a lot of traffic.' },
  { word: 'fast', meaning: '快的', example: 'The train is fast.' },
  { word: 'slow', meaning: '慢的', example: 'The bus is slow.' },
];

// Weather and Environment theme (84 words)
export const weatherEnvironmentWords: KETWord[] = [
  { word: 'weather', meaning: '天气', example: 'The weather is nice today.' },
  { word: 'sunny', meaning: '晴朗的', example: 'It is sunny today.' },
  { word: 'cloudy', meaning: '多云的', example: 'It is cloudy this morning.' },
  { word: 'rainy', meaning: '下雨的', example: 'It is rainy outside.' },
  { word: 'snowy', meaning: '下雪的', example: 'It is snowy in winter.' },
  { word: 'windy', meaning: '有风的', example: 'It is very windy.' },
  { word: 'foggy', meaning: '有雾的', example: 'It is foggy this morning.' },
  { word: 'stormy', meaning: '暴风雨的', example: 'It is stormy tonight.' },
  { word: 'sun', meaning: '太阳', example: 'The sun is bright.' },
  { word: 'cloud', meaning: '云', example: 'There are many clouds.' },
  { word: 'rain', meaning: '雨', example: 'I like the rain.' },
  { word: 'snow', meaning: '雪', example: 'We played in the snow.' },
  { word: 'wind', meaning: '风', example: 'The wind is strong.' },
  { word: 'fog', meaning: '雾', example: 'There is fog this morning.' },
  { word: 'storm', meaning: '暴风雨', example: 'There was a storm last night.' },
  { word: 'thunder', meaning: '雷', example: 'I heard thunder.' },
  { word: 'lightning', meaning: '闪电', example: 'I saw lightning.' },
  { word: 'ice', meaning: '冰', example: 'The road is icy.' },
  { word: 'rainbow', meaning: '彩虹', example: 'I saw a rainbow.' },
  { word: 'sky', meaning: '天空', example: 'The sky is blue.' },
  { word: 'temperature', meaning: '温度', example: 'What is the temperature?' },
  { word: 'hot', meaning: '热的', example: 'It is hot in summer.' },
  { word: 'warm', meaning: '温暖的', example: 'It is warm today.' },
  { word: 'cool', meaning: '凉爽的', example: 'It is cool this evening.' },
  { word: 'cold', meaning: '冷的', example: 'It is cold in winter.' },
  { word: 'freezing', meaning: '冰冻的', example: 'It is freezing outside.' },
  { word: 'spring', meaning: '春天', example: 'I like spring.' },
  { word: 'summer', meaning: '夏天', example: 'We swim in summer.' },
  { word: 'autumn', meaning: '秋天', example: 'Leaves fall in autumn.' },
  { word: 'winter', meaning: '冬天', example: 'It snows in winter.' },
  { word: 'January', meaning: '一月', example: 'My birthday is in January.' },
  { word: 'February', meaning: '二月', example: 'February is short.' },
  { word: 'March', meaning: '三月', example: 'Spring starts in March.' },
  { word: 'April', meaning: '四月', example: 'April is a rainy month.' },
  { word: 'May', meaning: '五月', example: 'May is beautiful.' },
  { word: 'June', meaning: '六月', example: 'School ends in June.' },
  { word: 'July', meaning: '七月', example: 'July is hot.' },
  { word: 'August', meaning: '八月', example: 'We travel in August.' },
  { word: 'September', meaning: '九月', example: 'School starts in September.' },
  { word: 'October', meaning: '十月', example: 'October is cool.' },
  { word: 'November', meaning: '十一月', example: 'November is cold.' },
  { word: 'December', meaning: '十二月', example: 'Christmas is in December.' },
  { word: 'tree', meaning: '树', example: 'There is a big tree.' },
  { word: 'flower', meaning: '花', example: 'I like flowers.' },
  { word: 'grass', meaning: '草', example: 'The grass is green.' },
  { word: 'forest', meaning: '森林', example: 'We walked in the forest.' },
  { word: 'nature', meaning: '自然', example: 'I love nature.' },
  { word: 'environment', meaning: '环境', example: 'We should protect the environment.' },
  { word: 'pollution', meaning: '污染', example: 'Air pollution is bad.' },
  { word: 'recycle', meaning: '回收', example: 'We recycle paper.' },
  { word: 'Earth', meaning: '地球', example: 'We live on Earth.' },
  { word: 'world', meaning: '世界', example: 'The world is big.' },
  { word: 'planet', meaning: '星球', example: 'Earth is a planet.' },
  { word: 'sea', meaning: '海', example: 'The sea is blue.' },
  { word: 'ocean', meaning: '海洋', example: 'The ocean is large.' },
  { word: 'land', meaning: '陆地', example: 'We live on land.' },
  { word: 'air', meaning: '空气', example: 'Fresh air is good.' },
  { word: 'water', meaning: '水', example: 'Water is important.' },
  { word: 'fire', meaning: '火', example: 'Be careful with fire.' },
  { word: 'stone', meaning: '石头', example: 'I found a stone.' },
  { word: 'rock', meaning: '岩石', example: 'The rock is big.' },
  { word: 'sand', meaning: '沙子', example: 'I like playing in the sand.' },
  { word: 'mud', meaning: '泥', example: 'Don\'t play in the mud.' },
  { word: 'plant', meaning: '植物', example: 'I water the plants.' },
  { word: 'animal', meaning: '动物', example: 'Animals are cute.' },
  { word: 'bird', meaning: '鸟', example: 'I saw a bird.' },
  { word: 'insect', meaning: '昆虫', example: 'I saw an insect.' },
  { word: 'butterfly', meaning: '蝴蝶', example: 'The butterfly is beautiful.' },
];

// Time and Dates theme (107 words)
export const timeDatesWords: KETWord[] = [
  { word: 'time', meaning: '时间', example: 'What time is it?' },
  { word: 'hour', meaning: '小时', example: 'I study for one hour.' },
  { word: 'minute', meaning: '分钟', example: 'Wait a minute.' },
  { word: 'second', meaning: '秒', example: 'One second please.' },
  { word: 'o\'clock', meaning: '点钟', example: 'It is 5 o\'clock.' },
  { word: 'quarter', meaning: '一刻钟', example: 'It is a quarter past three.' },
  { word: 'half', meaning: '半小时', example: 'It is half past six.' },
  { word: 'morning', meaning: '早晨', example: 'I wake up in the morning.' },
  { word: 'afternoon', meaning: '下午', example: 'I play in the afternoon.' },
  { word: 'evening', meaning: '晚上', example: 'I watch TV in the evening.' },
  { word: 'night', meaning: '夜晚', example: 'Good night!' },
  { word: 'midnight', meaning: '午夜', example: 'It is midnight.' },
  { word: 'noon', meaning: '中午', example: 'We eat at noon.' },
  { word: 'day', meaning: '天', example: 'What day is it?' },
  { word: 'week', meaning: '周', example: 'There are seven days in a week.' },
  { word: 'month', meaning: '月', example: 'There are twelve months.' },
  { word: 'year', meaning: '年', example: 'I am ten years old.' },
  { word: 'Monday', meaning: '星期一', example: 'I go to school on Monday.' },
  { word: 'Tuesday', meaning: '星期二', example: 'Tuesday is busy.' },
  { word: 'Wednesday', meaning: '星期三', example: 'Wednesday is OK.' },
  { word: 'Thursday', meaning: '星期四', example: 'Thursday is my favorite.' },
  { word: 'Friday', meaning: '星期五', example: 'Friday is fun.' },
  { word: 'Saturday', meaning: '星期六', example: 'I play on Saturday.' },
  { word: 'Sunday', meaning: '星期日', example: 'I rest on Sunday.' },
  { word: 'weekday', meaning: '工作日', example: 'I study on weekdays.' },
  { word: 'weekend', meaning: '周末', example: 'I play on weekends.' },
  { word: 'today', meaning: '今天', example: 'Today is Monday.' },
  { word: 'tomorrow', meaning: '明天', example: 'Tomorrow is Tuesday.' },
  { word: 'yesterday', meaning: '昨天', example: 'Yesterday was Sunday.' },
  { word: 'now', meaning: '现在', example: 'I am busy now.' },
  { word: 'soon', meaning: '不久', example: 'I will come soon.' },
  { word: 'later', meaning: '稍后', example: 'I will do it later.' },
  { word: 'early', meaning: '早', example: 'I wake up early.' },
  { word: 'late', meaning: '晚', example: 'I am late.' },
  { word: 'before', meaning: '之前', example: 'I eat before school.' },
  { word: 'after', meaning: '之后', example: 'I play after school.' },
  { word: 'always', meaning: '总是', example: 'I always study.' },
  { word: 'usually', meaning: '通常', example: 'I usually wake up at 7.' },
  { word: 'often', meaning: '经常', example: 'I often read books.' },
  { word: 'sometimes', meaning: '有时', example: 'I sometimes watch TV.' },
  { word: 'never', meaning: '从不', example: 'I never give up.' },
  { word: 'every day', meaning: '每天', example: 'I study every day.' },
  { word: 'once', meaning: '一次', example: 'I go once a week.' },
  { word: 'twice', meaning: '两次', example: 'I go twice a month.' },
  { word: 'first', meaning: '第一', example: 'I am first in class.' },
  { word: 'second', meaning: '第二', example: 'He is second.' },
  { word: 'third', meaning: '第三', example: 'She is third.' },
  { word: 'last', meaning: '最后', example: 'I finished last.' },
  { word: 'next', meaning: '下一个', example: 'Next week is holiday.' },
  { word: 'previous', meaning: '上一个', example: 'Previous week was busy.' },
  { word: 'begin', meaning: '开始', example: 'Let\'s begin.' },
  { word: 'start', meaning: '开始', example: 'School starts at 8.' },
  { word: 'finish', meaning: '结束', example: 'I finish at 4.' },
  { word: 'end', meaning: '结束', example: 'The movie ends at 9.' },
  { word: 'continue', meaning: '继续', example: 'Continue studying.' },
  { word: 'stop', meaning: '停止', example: 'Stop talking.' },
  { word: 'pause', meaning: '暂停', example: 'Pause the video.' },
  { word: 'wait', meaning: '等待', example: 'Wait for me.' },
  { word: 'clock', meaning: '钟', example: 'Look at the clock.' },
  { word: 'watch', meaning: '手表', example: 'I have a watch.' },
  { word: 'alarm', meaning: '闹钟', example: 'My alarm rings at 7.' },
  { word: 'calendar', meaning: '日历', example: 'Check the calendar.' },
  { word: 'date', meaning: '日期', example: 'What date is it?' },
  { word: 'schedule', meaning: '日程', example: 'Check my schedule.' },
  { word: 'timetable', meaning: '时间表', example: 'Look at the timetable.' },
  { word: 'plan', meaning: '计划', example: 'I have a plan.' },
  { word: 'appointment', meaning: '预约', example: 'I have an appointment.' },
  { word: 'meeting', meaning: '会议', example: 'We have a meeting.' },
  { word: 'deadline', meaning: '截止日期', example: 'The deadline is tomorrow.' },
  { word: 'future', meaning: '未来', example: 'I plan for the future.' },
  { word: 'past', meaning: '过去', example: 'In the past, I was young.' },
  { word: 'present', meaning: '现在', example: 'I live in the present.' },
  { word: 'age', meaning: '年龄', example: 'What is your age?' },
  { word: 'birthday', meaning: '生日', example: 'Happy birthday!' },
  { word: 'anniversary', meaning: '纪念日', example: 'Today is our anniversary.' },
  { word: 'celebrate', meaning: '庆祝', example: 'We celebrate together.' },
  { word: 'occasion', meaning: '场合', example: 'This is a special occasion.' },
  { word: 'event', meaning: '事件', example: 'The event is tomorrow.' },
  { word: 'festival', meaning: '节日', example: 'The festival is fun.' },
  { word: 'holiday', meaning: '假期', example: 'We have a holiday.' },
];

// Work and Jobs theme (86 words)
export const workJobsWords: KETWord[] = [
  { word: 'job', meaning: '工作', example: 'I have a job.' },
  { word: 'work', meaning: '工作', example: 'I work hard.' },
  { word: 'career', meaning: '职业', example: 'I plan my career.' },
  { word: 'profession', meaning: '职业', example: 'Teaching is a profession.' },
  { word: 'occupation', meaning: '职业', example: 'What is your occupation?' },
  { word: 'doctor', meaning: '医生', example: 'The doctor helped me.' },
  { word: 'nurse', meaning: '护士', example: 'The nurse is kind.' },
  { word: 'teacher', meaning: '老师', example: 'My teacher is nice.' },
  { word: 'student', meaning: '学生', example: 'I am a student.' },
  { word: 'engineer', meaning: '工程师', example: 'My dad is an engineer.' },
  { word: 'lawyer', meaning: '律师', example: 'My uncle is a lawyer.' },
  { word: 'police officer', meaning: '警察', example: 'The police officer helps us.' },
  { word: 'firefighter', meaning: '消防员', example: 'The firefighter is brave.' },
  { word: 'pilot', meaning: '飞行员', example: 'The pilot flies the plane.' },
  { word: 'driver', meaning: '司机', example: 'The driver is careful.' },
  { word: 'chef', meaning: '厨师', example: 'The chef cooks well.' },
  { word: 'waiter', meaning: '服务员', example: 'The waiter is polite.' },
  { word: 'waitress', meaning: '女服务员', example: 'The waitress is helpful.' },
  { word: 'manager', meaning: '经理', example: 'The manager is busy.' },
  { word: 'boss', meaning: '老板', example: 'My boss is kind.' },
  { word: 'employee', meaning: '员工', example: 'I am an employee.' },
  { word: 'colleague', meaning: '同事', example: 'My colleague is friendly.' },
  { word: 'worker', meaning: '工人', example: 'The worker is strong.' },
  { word: 'office', meaning: '办公室', example: 'I work in an office.' },
  { word: 'factory', meaning: '工厂', example: 'The factory is big.' },
  { word: 'company', meaning: '公司', example: 'I work for a company.' },
  { word: 'business', meaning: '生意', example: 'I do business.' },
  { word: 'shop', meaning: '商店', example: 'I work in a shop.' },
  { word: 'store', meaning: '商店', example: 'The store is open.' },
  { word: 'hospital', meaning: '医院', example: 'I work in a hospital.' },
  { word: 'school', meaning: '学校', example: 'I work at a school.' },
  { word: 'restaurant', meaning: '餐厅', example: 'I work in a restaurant.' },
  { word: 'hotel', meaning: '酒店', example: 'I work in a hotel.' },
  { word: 'salary', meaning: '薪水', example: 'My salary is good.' },
  { word: 'wage', meaning: '工资', example: 'I get my wage.' },
  { word: 'money', meaning: '钱', example: 'I earn money.' },
  { word: 'earn', meaning: '赚取', example: 'I earn money.' },
  { word: 'pay', meaning: '支付', example: 'I get paid.' },
  { word: 'income', meaning: '收入', example: 'My income is OK.' },
  { word: 'experience', meaning: '经验', example: 'I have experience.' },
  { word: 'skill', meaning: '技能', example: 'I have many skills.' },
  { word: 'training', meaning: '培训', example: 'I need training.' },
  { word: 'education', meaning: '教育', example: 'Education is important.' },
  { word: 'qualification', meaning: '资格', example: 'I have qualifications.' },
  { word: 'degree', meaning: '学位', example: 'I have a degree.' },
  { word: 'interview', meaning: '面试', example: 'I have an interview.' },
  { word: 'application', meaning: '申请', example: 'I sent an application.' },
  { word: 'resume', meaning: '简历', example: 'I wrote my resume.' },
  { word: 'CV', meaning: '简历', example: 'I updated my CV.' },
  { word: 'hire', meaning: '雇佣', example: 'They hired me.' },
  { word: 'employ', meaning: '雇佣', example: 'They employ workers.' },
  { word: 'fire', meaning: '解雇', example: 'They fired him.' },
  { word: 'retire', meaning: '退休', example: 'My dad retired.' },
  { word: 'promote', meaning: '晋升', example: 'I was promoted.' },
  { word: 'demote', meaning: '降职', example: 'He was demoted.' },
  { word: 'transfer', meaning: '调动', example: 'I was transferred.' },
  { word: 'shift', meaning: '班次', example: 'I work the night shift.' },
  { word: 'full-time', meaning: '全职', example: 'I work full-time.' },
  { word: 'part-time', meaning: '兼职', example: 'I work part-time.' },
  { word: 'temporary', meaning: '临时', example: 'This is temporary.' },
  { word: 'permanent', meaning: '永久', example: 'This is permanent.' },
  { word: 'contract', meaning: '合同', example: 'I signed a contract.' },
  { word: 'deadline', meaning: '截止日期', example: 'The deadline is tomorrow.' },
  { word: 'task', meaning: '任务', example: 'I finished my task.' },
  { word: 'project', meaning: '项目', example: 'I work on a project.' },
  { word: 'meeting', meaning: '会议', example: 'We have a meeting.' },
  { word: 'report', meaning: '报告', example: 'I wrote a report.' },
  { word: 'email', meaning: '邮件', example: 'I send emails.' },
  { word: 'phone', meaning: '电话', example: 'I answer the phone.' },
  { word: 'customer', meaning: '客户', example: 'The customer is happy.' },
  { word: 'client', meaning: '客户', example: 'I meet clients.' },
  { word: 'service', meaning: '服务', example: 'We provide good service.' },
  { word: 'product', meaning: '产品', example: 'We make products.' },
  { word: 'team', meaning: '团队', example: 'I work in a team.' },
  { word: 'department', meaning: '部门', example: 'I work in the sales department.' },
  { word: 'boss', meaning: '上司', example: 'My boss is nice.' },
  { word: 'staff', meaning: '员工', example: 'The staff is helpful.' },
  { word: 'busy', meaning: '忙碌', example: 'I am busy.' },
  { word: 'hard', meaning: '努力', example: 'I work hard.' },
  { word: 'easy', meaning: '容易', example: 'This job is easy.' },
  { word: 'difficult', meaning: '困难', example: 'This job is difficult.' },
  { word: 'stressful', meaning: '压力大', example: 'This job is stressful.' },
  { word: 'relaxing', meaning: '轻松', example: 'This job is relaxing.' },
];

// Clothes and Accessories theme (83 words)
export const clothesAccessoriesWords: KETWord[] = [
  { word: 'clothes', meaning: '衣服', example: 'I buy clothes.' },
  { word: 'clothing', meaning: '服装', example: 'I like this clothing.' },
  { word: 'shirt', meaning: '衬衫', example: 'I wear a shirt.' },
  { word: 'T-shirt', meaning: 'T恤', example: 'I like T-shirts.' },
  { word: 'blouse', meaning: '女衬衫', example: 'She wears a blouse.' },
  { word: 'dress', meaning: '连衣裙', example: 'She wears a dress.' },
  { word: 'skirt', meaning: '裙子', example: 'I wear a skirt.' },
  { word: 'jacket', meaning: '夹克', example: 'I wear a jacket.' },
  { word: 'coat', meaning: '外套', example: 'I wear a coat in winter.' },
  { word: 'sweater', meaning: '毛衣', example: 'I wear a sweater.' },
  { word: 'cardigan', meaning: '开衫', example: 'She wears a cardigan.' },
  { word: 'hoodie', meaning: '卫衣', example: 'I like hoodies.' },
  { word: 'jeans', meaning: '牛仔裤', example: 'I wear jeans.' },
  { word: 'trousers', meaning: '裤子', example: 'I wear trousers.' },
  { word: 'pants', meaning: '裤子', example: 'I like these pants.' },
  { word: 'shorts', meaning: '短裤', example: 'I wear shorts in summer.' },
  { word: 'leggings', meaning: '紧身裤', example: 'She wears leggings.' },
  { word: 'suit', meaning: '西装', example: 'He wears a suit.' },
  { word: 'uniform', meaning: '制服', example: 'I wear a uniform.' },
  { word: 'pyjamas', meaning: '睡衣', example: 'I wear pyjamas at night.' },
  { word: 'underwear', meaning: '内衣', example: 'I need new underwear.' },
  { word: 'socks', meaning: '袜子', example: 'I wear socks.' },
  { word: 'shoes', meaning: '鞋子', example: 'I wear shoes.' },
  { word: 'boots', meaning: '靴子', example: 'I wear boots in winter.' },
  { word: 'sandals', meaning: '凉鞋', example: 'I wear sandals in summer.' },
  { word: 'trainers', meaning: '运动鞋', example: 'I wear trainers.' },
  { word: 'sneakers', meaning: '运动鞋', example: 'I like sneakers.' },
  { word: 'heels', meaning: '高跟鞋', example: 'She wears heels.' },
  { word: 'slippers', meaning: '拖鞋', example: 'I wear slippers at home.' },
  { word: 'hat', meaning: '帽子', example: 'I wear a hat.' },
  { word: 'cap', meaning: '帽子', example: 'I wear a cap.' },
  { word: 'scarf', meaning: '围巾', example: 'I wear a scarf.' },
  { word: 'gloves', meaning: '手套', example: 'I wear gloves.' },
  { word: 'belt', meaning: '腰带', example: 'I wear a belt.' },
  { word: 'tie', meaning: '领带', example: 'He wears a tie.' },
  { word: 'bag', meaning: '包', example: 'I have a bag.' },
  { word: 'handbag', meaning: '手提包', example: 'She has a handbag.' },
  { word: 'purse', meaning: '钱包', example: 'I have a purse.' },
  { word: 'wallet', meaning: '钱包', example: 'I have a wallet.' },
  { word: 'backpack', meaning: '背包', example: 'I carry a backpack.' },
  { word: 'watch', meaning: '手表', example: 'I wear a watch.' },
  { word: 'ring', meaning: '戒指', example: 'She wears a ring.' },
  { word: 'necklace', meaning: '项链', example: 'She wears a necklace.' },
  { word: 'bracelet', meaning: '手链', example: 'She wears a bracelet.' },
  { word: 'earring', meaning: '耳环', example: 'She wears earrings.' },
  { word: 'glasses', meaning: '眼镜', example: 'I wear glasses.' },
  { word: 'sunglasses', meaning: '太阳镜', example: 'I wear sunglasses.' },
  { word: 'red', meaning: '红色', example: 'I like red.' },
  { word: 'blue', meaning: '蓝色', example: 'I like blue.' },
  { word: 'green', meaning: '绿色', example: 'I like green.' },
  { word: 'yellow', meaning: '黄色', example: 'I like yellow.' },
  { word: 'orange', meaning: '橙色', example: 'I like orange.' },
  { word: 'purple', meaning: '紫色', example: 'I like purple.' },
  { word: 'pink', meaning: '粉色', example: 'I like pink.' },
  { word: 'black', meaning: '黑色', example: 'I like black.' },
  { word: 'white', meaning: '白色', example: 'I like white.' },
  { word: 'grey', meaning: '灰色', example: 'I like grey.' },
  { word: 'brown', meaning: '棕色', example: 'I like brown.' },
  { word: 'beige', meaning: '米色', example: 'I like beige.' },
  { word: 'gold', meaning: '金色', example: 'I like gold.' },
  { word: 'silver', meaning: '银色', example: 'I like silver.' },
  { word: 'cotton', meaning: '棉', example: 'This is cotton.' },
  { word: 'wool', meaning: '羊毛', example: 'This is wool.' },
  { word: 'leather', meaning: '皮革', example: 'This is leather.' },
  { word: 'silk', meaning: '丝绸', example: 'This is silk.' },
  { word: 'denim', meaning: '牛仔布', example: 'This is denim.' },
  { word: 'synthetic', meaning: '合成材料', example: 'This is synthetic.' },
  { word: 'size', meaning: '尺寸', example: 'What size is this?' },
  { word: 'small', meaning: '小号', example: 'This is small.' },
  { word: 'medium', meaning: '中号', example: 'This is medium.' },
  { word: 'large', meaning: '大号', example: 'This is large.' },
  { word: 'XL', meaning: '特大号', example: 'This is XL.' },
  { word: 'fit', meaning: '合身', example: 'This fits me.' },
  { word: 'tight', meaning: '紧的', example: 'This is tight.' },
  { word: 'loose', meaning: '宽松的', example: 'This is loose.' },
  { word: 'long', meaning: '长的', example: 'This is long.' },
  { word: 'short', meaning: '短的', example: 'This is short.' },
  { word: 'wear', meaning: '穿', example: 'I wear clothes.' },
  { word: 'put on', meaning: '穿上', example: 'Put on your coat.' },
  { word: 'take off', meaning: '脱下', example: 'Take off your shoes.' },
  { word: 'try on', meaning: '试穿', example: 'Try on this dress.' },
  { word: 'change', meaning: '更换', example: 'I changed my clothes.' },
  { word: 'wash', meaning: '洗', example: 'I wash my clothes.' },
  { word: 'dry', meaning: '晾干', example: 'Dry the clothes.' },
  { word: 'iron', meaning: '熨烫', example: 'Iron the shirt.' },
  { word: 'fold', meaning: '折叠', example: 'Fold the clothes.' },
  { word: 'hang', meaning: '挂', example: 'Hang the clothes.' },
];